import { render, staticRenderFns } from "./PreviewClassicAttribute.vue?vue&type=template&id=bb4f51da&scoped=true"
import script from "./PreviewClassicAttribute.vue?vue&type=script&lang=js"
export * from "./PreviewClassicAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4f51da",
  null
  
)

export default component.exports